<div class="modal z-index-1">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Količina za: {{ title }}</h3>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label class="form-label">Izdato</label>
        <input type="number"
               class="form-control" [(ngModel)]="form.quantityIssued">
      </div>
      <div class="form-group">
        <label class="form-label">Vraćeno</label>
        <input type="number"
               class="form-control" [(ngModel)]="form.quantityReturned">
      </div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()">Sačuvaj</button>
    </div>
  </div>
</div>
